import React from 'react';

import { cn } from '@epoch-ui/lib/utils';

const Skeleton = ({ className, ...props }: React.HTMLAttributes<HTMLDivElement>): JSX.Element => {
  return (
    <div className={cn('tw-animate-pulse tw-rounded-md tw-bg-muted/20', className)} {...props} />
  );
};

export { Skeleton };
